import React from 'react';
import {Navigate} from 'react-router';
import CollectionLayout from '../features/collection/CollectionLayout';
import CollectionQueueLayout from '../features/collection/CollectionQueueLayout';
import ListCollectionTasks from '../features/collection/pages/ListCollectionTasks';
import CollectionTaskFormPage from '../features/collection/pages/CollectionTaskFormPage';
import CollectionTaskDetailPage from '../features/collection/pages/CollectionTaskDetailPage';
import ListCollectionMaterials from '../features/collection/pages/ListCollectionMaterials';
import CollectionMaterialEditorPage from '../features/collection/pages/CollectionMaterialEditorPage';
import ListCollectionIirs from '../features/collection/pages/ListCollectionIirs';
import IirEditorPage from '../features/collection/pages/IirEditorPage';

/**
 * Full Collection nav routes for policymaker, collection_manager, collector, and admin.
 */
export const collectionChildRoutes = [
    {
        path: 'collection',
        element: <CollectionLayout/>,
        children: [
            {index: true, element: <Navigate to="tasks" replace/>},
            {path: 'tasks', element: <ListCollectionTasks/>},
            {path: 'tasks/create', element: <CollectionTaskFormPage/>},
            {path: 'tasks/new', element: <Navigate to="/collection/tasks/create" replace/>},
            {path: 'tasks/:taskId/edit', element: <CollectionTaskFormPage/>},
            {path: 'tasks/:taskId', element: <CollectionTaskDetailPage/>},
            {path: 'data', element: <ListCollectionMaterials/>},
            {path: 'data/:materialId/edit', element: <CollectionMaterialEditorPage/>},
            {path: 'iir', element: <ListCollectionIirs/>},
            {path: 'iir/:reportId/edit', element: <IirEditorPage/>},
        ],
    },
];

/**
 * Deep links for roles without Collection nav (analyst, reviewer, briefer, real_user, …).
 * Task detail + material editor only.
 * Wrapped in CollectionQueueLayout so the upload queue processor and panel are always mounted.
 */
export const collectionDeepLinkRoutes = [
    {
        element: <CollectionQueueLayout/>,
        children: [
            {path: 'collection/tasks/create', element: <CollectionTaskFormPage/>},
            {path: 'collection/tasks/new', element: <Navigate to="/collection/tasks/create" replace/>},
            {path: 'collection/tasks/:taskId', element: <CollectionTaskDetailPage/>},
            {path: 'collection/data/:materialId/edit', element: <CollectionMaterialEditorPage/>},
        ],
    },
];
